// TournamentContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import config from "../config/default.json";
const base_url = config.base_url;

const TournamentContext = createContext({
  tournament: null,
  tournamentID: null,
  setTournamentID: () => {},
});

export function useTournament() {
  return useContext(TournamentContext);
}

export function TournamentProvider({ children }) {
  const [tournamentID, setTournamentID] = useState(null);
  const [tournament, setTournament] = useState(null);
  const [linkindex, setLinkindex] = useState(null);

  // Automatically fetch tournament when tournamentID changes
  useEffect(() => {
    if (!linkindex) return;

    const fetchTournamentByLinkParam = async (param) => {
      try {
        const response = await axios.get(`${base_url}/api/tournament/${linkindex}`);
        if (response.data) {
          setTournament(response.data);
          setTournamentID(response.data._id);
        } else {
          console.warn("Invalid tournament ID");
        }
      } catch (error) {
        console.error("Error fetching tournament:", error);
      }
    };

    fetchTournamentByLinkParam(linkindex);
  }, [linkindex]);

  return (
    <TournamentContext.Provider value={{ tournament, tournamentID, setTournamentID, linkindex, setLinkindex }}>
      {children}
    </TournamentContext.Provider>
  );
}
